import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapperProps: BoxProps = {
  sx: {
    'div:first-child': {
      display: 'flex',
      flexDir: 'column',
      color: 'delta.500',
      fontSize: 'xs',
      fontWeight: 'medium',
      alignItems: 'flex-start',
      svg: {
        boxSize: '2.5',
        mr: '1',
        mt: '-1px',
      },
      '.chakra-link': {
        mb: '4',
      },
    },
  },
};

export const TextForgotPasswordSuccess: CSSObject = {
  color: 'gray.500',
  fontSize: 'sm',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'medium',
  mb: '2',

  '+ a': {
    color: 'gray.500',
    fontSize: 'sm',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'medium',
    mx: 0,
    display: 'inline',
  },
};
